import { createContext, useContext, useState, ReactNode } from "react";
import VisitForm from "./VisitForm";

type Ctx = { open: () => void; close: () => void; isOpen: boolean };

const VisitFormCtx = createContext<Ctx>({
  open: () => {},
  close: () => {},
  isOpen: false,
});

export const useVisitForm = () => useContext(VisitFormCtx);

export const VisitFormProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <VisitFormCtx.Provider
      value={{ isOpen, open: () => setIsOpen(true), close: () => setIsOpen(false) }}
    >
      {children}
      <VisitForm open={isOpen} onClose={() => setIsOpen(false)} />
    </VisitFormCtx.Provider>
  );
};
